export interface IDashboardStore {
  currentView: string;
}

export const dashboardStore = {
  currentView: 'RTWorkspace',
};
